import unboundProcessValue from "./processValue";

export default function (data, formData, entity, onlyPresent = false) {
    const entityPlural = entity + 's';
    const entityItems = entity + 'Items';
    const companions = this.$wire.get(entityPlural);
    const processValue = unboundProcessValue.bind(this);
    data[entityPlural] = companions.map((companion) => {
        // Deep copy the saved companion data so fields not present in the
        // current step's DOM are preserved (e.g. on non-companion steps in
        // multi-step forms). Only fields actually found in the DOM will be
        // overridden below.
        let result = JSON.parse(JSON.stringify(companion));
        if (!result.extended_fields || typeof result.extended_fields !== 'object') {
            result.extended_fields = {};
        }
        this.$wire.get(entityItems).forEach((item, index) => {
            if (item.type === 'bookable-group') {
                this.getBookableGroupData(item, data, formData, `${entityPlural}.${companion.key}`, onlyPresent);
                return;
            }
            const field = item.field;
            // AIRLST-5622: an orphaned item (its field was deleted) has nothing to collect.
            if (!field || field.read_only) {
                return;
            }
            const fieldKey = `${entityPlural}.${companion.key}.${field.form_mapping}`;
            const exists = document.querySelector(`[name="${fieldKey}"]`);
            if (onlyPresent && !exists && item.type !== 'multiselect') {
                return;
            }
            let value = formData.get(fieldKey) || null;
            // Fallback to DOM value for browsers that don't commit autofill to FormData
            if (value === null && exists && exists.value && exists.type !== 'checkbox' && exists.type !== 'radio') {
                value = exists.value
            }
            if (field.model !== 'guest') {
                if (!result[field.model]) {
                    result[field.model] = {extended_fields: {}};
                }
                if (!result[field.model].extended_fields) {
                    result[field.model].extended_fields = {};
                }
                if (!field.is_extended) {
                    result[field.model][field.key] = processValue(
                        item,
                        value,
                        fieldKey
                    );
                } else {
                    result[field.model]['extended_fields'][field.key] = processValue(
                        item,
                        value,
                        fieldKey
                    );
                }
            } else {
                result['extended_fields'][field.key] = processValue(
                    item,
                    value,
                    fieldKey
                );
            }
        });
        return result;
    })


}
